import { useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { Loading } from '@centerpiece/components';
import { EventActualTab } from './EventActualTab';
import { useItemContext } from 'contexts/item.context';
import { EventTab } from './EventTab';
import { Box, Button, Paper, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

export interface CombinedEventTabProps {
  onClose?: Function;
  onSubmit?: (values: any) => void | Promise<any>;
  back?: boolean;
}

export const CombinedEventTab = (props: CombinedEventTabProps) => {
  const { onClose = () => {}, back = false } = props;
  const { itemLoading } = useItemContext();
  const [value, setValue] = useState('manual');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };
  if (itemLoading) {
    return <Loading />;
  } else {
    return (
      <>
        {back && (
          <Box sx={{}}>
            <Button
              startIcon={<ArrowBack />}
              color="secondary"
              onClick={() => onClose()}
            >
              <Typography
                sx={{
                  lineHeight: 1,
                  marginTop: 0.25,
                  fontSize: 15,
                }}
              >
                Back
              </Typography>
            </Button>
          </Box>
        )}
        <FormControl sx={{ mb: 2, p: 1 }}>
          <FormLabel sx={{ fontWeight: '600' }}>
            <u>Scheduling Options</u>
          </FormLabel>
          <RadioGroup value={value} onChange={handleChange}>
            <FormControlLabel
              value="manual"
              control={<Radio />}
              label="Schedule Manually"
            />
            <FormControlLabel
              value="availability"
              control={<Radio />}
              label="Send Availability Request"
            />
          </RadioGroup>
        </FormControl>
        <Paper sx={{ p: 3 }}>
          {value === 'manual' ? (
            <EventActualTab {...props} back={false} />
          ) : (
            <EventTab {...props} back={false} />
          )}
        </Paper>
      </>
    );
  }
};
